<template>
  <div class="contact-section">
    <div class="contact-section--bg"></div>
    <b-container>
      <b-row>
        <b-col cols="12" lg="7" xl="8">
          <div class="contact-text--margin d-flex flex-column align-items-center align-items-sm-start">
            <div class="contact-section__title">
              <h1 class="contact-section__title--style contact-section--text-color">
                {{ mainTitle }}
              </h1>
            </div>
            <div class="contact-section__par mt-2 mt-sm-4">
              <p class="contact-section__par--style contact-section--text-color">
                {{ mainText }}
              </p>
            </div>
            <ksr-carousel class="contact-carousel--margin"></ksr-carousel>
          </div>
        </b-col>
        <b-col class="d-flex justify-content-center" cols="12" lg="5" xl="4">
          <div class="contact-form--margin">
            <ksr-contact-form
              title="Contáctanos"
              subtitle="Nos comunicaremos contigo a la brevedad"
              button="Enviar"
              sentTitle="¡Gracias por tu preferencia!"
              sentText="Nos comunicaremos contigo a la brevedad"
            ></ksr-contact-form>
          </div>
        </b-col>
      </b-row>
    </b-container>
  </div>
</template>

<script>
import ContactForm from './ContactForm/ContactForm'
import Carousel from './Carousel/Carousel'

export default {
  name: 'ContactSection',
  props: {
    mainTitle: String, 
    mainText: String
    },
  components: {
    'ksr-contact-form': ContactForm,
    'ksr-carousel': Carousel,
  }
}
</script>

<style scoped>
  /* Text classes */
  .contact-section__title--style{
    font-size: 24px;
    font-weight: 700;
    line-height: 156.19%;
    text-align: center;
    text-transform: uppercase;
    transition: all 0.3s;
  }
  .contact-section__par--style{
    font-size: 16px;
    font-weight: 300;
    line-height: 220%;
    text-align: center;
    transition: all 0.3s;
  }
  .contact-section--text-color{
    color: var(--ksr-white);
  }
  /* Wrappers */
  .contact-section__title{
    width: 300px;
    transition: width 0.3s;
  }
  .contact-section__par{
    width: 275px;
    transition: width 0.3s;
  }
  /* Margins */
  .contact-text--margin{
    margin-top: 43px;
    transition: margin-top 0.3s;
  }
  .contact-carousel--margin{
    margin-top: 95px;
    transition: margin-top 0.3s;
  }
  .contact-form--margin{
    margin-top: 140px;
    transition: margin-top 0.3s;
  }
  .contact-section{
    padding-top: 85px;
  }
  /* Backgrounds */
  .contact-section--bg{
    width: 100%;
    height: 730px;
    position: absolute;
    background-image: url('~@/assets/wave.svg');
    background-repeat: no-repeat;
    background-size: cover;
    transition: background-size 0.3s;
  }
  @media (min-width: 576px) {
    .contact-section__title--style{
      font-size: 38px;
      font-weight: 700;
      line-height: 135.69%;
      text-align: left;
      transition: all 0.3s;
    }
    .contact-section__par--style{
      font-size: 18px;
      line-height: 185%;
      text-align: left;
      text-justify: initial;
      transition: all 0.3s;
    }
    /* Wrappers */
    .contact-section__title{
      width: 100%;
      transition: width 0.3s;
    }
    .contact-section__par{
      width: 100%;
      transition: width 0.3s;
    }
    /* Margins */
    .contact-text--margin{
      margin-top: 60px;
      transition: margin-top 0.3s;
    }
    .contact-carousel--margin{
      margin-top: 50px;
      transition: margin-top 0.3s;
    }
    .contact-form--margin{
      margin-top: 90px;
      transition: margin-top 0.3s;
    }
  }
  @media (min-width: 768px) {
    /* Wrappers */
    .contact-section__title{
      width: 100%;
      transition: width 0.3s;
    }
    .contact-section__par{
      width: 100%;
      transition: width 0.3s;
    }
  }
  @media (min-width: 992px) {
     /* Wrappers */
    .contact-section__title{
      width: 450px;
      transition: width 0.3s;
    }
    .contact-section__par{
      width: 480px;
      transition: width 0.3s;
    }
    /* Margins */
    .contact-carousel--margin{
      margin-top: 20px;
      transition: margin-top 0.3s;
    }
    .contact-form--margin{
      margin-top: 60px;
      transition: margin-top 0.3s;
    }
  }
  @media (min-width: 1200px) {
    /* Wrappers */
    .contact-section__title{
      width: 630px;
      transition: width 0.3s;
    }
    .contact-section__par{
      width: 650px;
      transition: width 0.3s;
    }
    /* Margins */
    .contact-carousel--margin{
      margin-top: 20px;
      transition: margin-top 0.3s;
    }
    /* Backgrounds */
    .contact-section--bg{
      background-size: contain;
      transition: background-size 0.3s;
    }
  }
  @media (min-width: 1700px) {
    .contact-section--bg{
      background-image: url('~@/assets/wave-2.svg');
      background-size: contain;
      transition: background-size 0.3s, background-image 0.3s;
    }
  }
</style>

